<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="page-header">Users</h3>
  </mat-card-title>

  <div fxLayout="row wrap">

    <div fxFlex="100%" class="m-gap p-gap text-right">

      <div fxFlex.gt-sm="70%" fxFlex="100%" style="margin-top: 17px">
        <mat-form-field appearance="outline" style="width:98.5%">
          <mat-label> Search</mat-label>
          <input matInput type="text" [(ngModel)]="searchTerm" (keyup)="searchUsers($event.target.value)" />
        </mat-form-field>
        <div style="margin-top: 5px; text-align: left; margin-left: 12px">
          <button mat-raised-button (click)="sortAToZ()" matTooltip="Sort by name A-Z">Sort A-Z</button>
          <button mat-raised-button (click)="sortByLogin()" class="margin-left-10"
            matTooltip="Sort by most recent login">Sort by Login</button>
        </div>
      </div>

      <div fxFlex.gt-sm="30%" fxFlex="100%" style="margin-top:20px">
        <button mat-raised-button [disabled]="currentPage === 1" *ngIf="displayedUsers.length < users.length"
          (click)="changePage(-1)" class="margin-left-10"><i class="fa fa-arrow-left"></i>
        </button>
        <button mat-raised-button (click)="changePage(1)" *ngIf="displayedUsers.length < users.length"
          class="margin-left-10">
          <i class="fa fa-arrow-right"></i></button>
        <a mat-raised-button class="mat-primary margin-left-10"
          *ngIf="hasPermission(permissionTypes.Users, permissionOptions.Edit)" routerLink="add">Add New User</a>
      </div>


    </div>


    <div fxFlex="100%" class="m-gap p-gap" style="margin-left: 10px">
      <table mat-table [dataSource]="displayedUsers" class="mat-elevation-z8 w-100">

        <!-- User Info Column -->
        <ng-container matColumnDef="userInfo">
          <th mat-header-cell *matHeaderCellDef> User Info</th>
          <td mat-cell *matCellDef="let user">
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="p-gap">
              <div class="user-avatar">
                <img *ngIf="user.avatar" src="{{user.avatar || 'data:,'}}" width="48" height="48" alt="user">
                <i *ngIf="!user.avatar" class="fa fa-image fa-2x"></i>
              </div>
              <div>
                <div>
                  <strong>{{user.firstName}} {{user.lastName}}</strong>
                  <span *ngIf="user.jobTitle"> ({{user.jobTitle}})</span>
                </div>
                <div>
                  <a href="mailto://{{user.emailAlias || user.email}}">
                    <span matTooltip="Logon Name">{{user.email}}</span>
                    <span *ngIf="user.emailAlias && user.emailAlias !== user.email" matTooltip="Email"> /
                      {{user.emailAlias}}</span>
                  </a>
                  <span *ngIf="user.twoFAEnabled === 1" class="margin-left-10">
                    <i class="fa fa-check-double" [matTooltip]="'Two Factor Authentication Enabled'"></i>
                  </span>
                </div>
                <div fxLayout="row" fxLayoutGap="10px">
                  <span class="pro-des" matTooltip="User Type">{{user.userType | humanize}}</span>
                  <span matTooltip="Auth Provider">{{user.authProvider}}</span>
                  <span class="{{user.userStatus}} pro-des" matTooltip="User Status">{{user.userStatus |
                    humanize}}</span>
                  <span *ngIf="user.roleName" matTooltip="Role">{{user.roleName}}</span>
                  <span *ngIf="!user.roleName" matTooltip="Role" style="color:crimson;">MISSING</span>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Logins Column -->
        <ng-container matColumnDef="logins">
          <th mat-header-cell *matHeaderCellDef> Last Logins</th>
          <td mat-cell *matCellDef="let user">
            <div *ngIf="user.history">
              <div *ngFor="let history of user.history" [matTooltip]="history.created | amTimeAgo">
                <span class="pro-des">{{history.created | date:'shortDate'}} {{history.created |
                  date:'shortTime'}}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions</th>
          <td mat-cell *matCellDef="let user">
            <button mat-icon-button class="action-icon" [routerLink]="['/admin/users', user.userId]" matTooltip="Edit"
              *ngIf="hasPermission(permissionTypes.Users, permissionOptions.Edit) && (isSurvaleAdmin || !isBEAdmin(user))">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="action-icon" (click)="setTwoFactorAuthentication(user)"
              matTooltip="Two Factor Authentication"
              *ngIf="hasPermission(permissionTypes.TwoFactorAuthentication, permissionOptions.Edit)">
              <mat-icon>looks_two</mat-icon>
            </button>
            <button mat-icon-button class="action-icon" (click)="setPassword(user)" matTooltip="Set Password"
              *ngIf="isSurvaleAdmin || hasPermission(permissionTypes.SetPassword, permissionOptions.Edit)">
              <mat-icon>vpn_key</mat-icon>
            </button>
            <button mat-icon-button class="action-icon" (click)="deleteUser(user)" matTooltip="Delete User"
              *ngIf="isSurvaleAdmin || hasPermission(permissionTypes.DeleteUser, permissionOptions.Edit)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

  </div>
</mat-card>

<!--  <pre>{{users | json}}</pre>-->
